import { humanize } from 'utils/helpers';

const RNA_COUNT_COLUMN_PATTERN =
  /^([^.]+)\.counts_in_segmentation\.([^.]+)\.dilation\.(\d+(?:\.\d+)?)um(?:\.(binned|pos))?$/;

export const parseRnaCountColumn = (column: string) => {
  const match = RNA_COUNT_COLUMN_PATTERN.exec(column);
  if (!match) {
    return undefined;
  }
  const [, probeId, compartment, dilation, representation] = match;
  return { probeId, compartment, dilation, representation };
};

export const getRnaCountColumnDisplayName = (column: string, resolveDisplayName?: (identifier: string) => string) => {
  const parsed = parseRnaCountColumn(column);
  if (!parsed) {
    return undefined;
  }
  const { probeId, compartment, dilation, representation } = parsed;
  const displayName = resolveDisplayName?.(probeId);
  const probeNumber = /^rna-prob(\d+)$/.exec(probeId)?.[1];
  const probeLabel =
    displayName && displayName !== probeId ? displayName : probeNumber ? `RNA probe ${probeNumber}` : probeId;
  if (representation === 'binned') {
    return `${probeLabel} score (${dilation}um dilation)`;
  }
  const suffix = representation === 'pos' ? ', positive' : '';
  return `${probeLabel} ${humanize(compartment).toLocaleLowerCase()} count (${dilation} \u00b5m dilation${suffix})`;
};
